export default __webpack_public_path__ + "static/media/EM0020.34I-18851_-24648_0.248db3c4.jpg";